import { Injectable } from '@angular/core';
import { AuthAPIService } from '../_api/auth-api.service';

@Injectable({
  providedIn: 'root'
})
export class AuthUtilService {

  constructor(private _authService: AuthAPIService) { }

  async isLoggedIn(){
    if(!localStorage.getItem('loggedIn')) return false
    let isValidUser
    await this._authService.verifyUserID().toPromise().catch(err => { isValidUser=err.status==200 } )
    return isValidUser
  }
}
